import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  IconButton

} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';


import withAlert from "../../../../hoc/withAlert";
import {
  getEventeatingByDateAndEatingSelector,
  addEventeatingMeal,
  deleteEventeatingMeal
} from '../../../../store/eventeating';
import {
  getMealSelector,
} from '../../../../store/meal';


const useStyles = makeStyles(theme => ({
  nestedHead: {
    paddingLeft: theme.spacing(4),
  },
  nested: {
    paddingLeft: theme.spacing(6),
  },
  weekend: {
    backgroundColor: '#e0f2f1'
  },
  listItemText:{
    fontSize: 13
  }
}));

const customSelectStyle = {
  control: styles => ({ ...styles, fontSize: 13, fontFamily:"Roboto, Helvetica, Arial"}),
  option: (base, state) => ({
    ...base,
    fontSize: 14,
    fontFamily:"Roboto, Helvetica, Arial"
  })
}


const Eating = props => {
  const { name, meetingId, date, eating, onCheckedOne,setSnackMessage, setSnackType, setOpenSnack } = props;
  
  const classes = useStyles();

  const mealData = useSelector(getMealSelector);
  const eventeatings = useSelector(getEventeatingByDateAndEatingSelector(meetingId, date, eating.id));
  const dispatch = useDispatch();

    
  
  const [dishes, setDishes] = useState([])
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState({});


  useEffect(() => {
    if(eventeatings){
      // console.log('eventeatings.meals',eventeatings.meals);
      // console.log('mealData',mealData);
      if(eventeatings.meals && eventeatings.meals.length > 0){

  // 
    // console.log('chosenDishes',chosenDishes);
      const chosenDishes= mealData.filter( m => eventeatings.meals.includes(m.id))
      // console.log('chosenDishes',chosenDishes);
      setDishes(chosenDishes)

      const currentOptions = mealData.filter( m => !eventeatings.meals.includes(m.id)).map(o => ({"value": o.id, "label":`${o.id}. ${o.name}`}))
      // console.log('currentOptions',currentOptions);
      // const currentOptions = mealData.map(o => ({"value": o.id, "label":`${o.id}. ${o.name}`}))
      setOptions(currentOptions)
      if(currentOptions.length > 0){
        setSelectedValue(currentOptions[0])
      }
    }
    }
    // tableRef.current.onToggleDetailPanel([0],rowData => <div>{rowData.name}</div>)
  }, [eventeatings]);



  const handleSelectChange = selectedOption => {
    setSelectedValue(selectedOption);
    // console.log('selectedOption',selectedOption);
  };

  const handleAdd = async () => {
    await dispatch(addEventeatingMeal({mealId:selectedValue.value, eventeatingId: eventeatings.id}))
  }

  const handleDelete = async (mealId) => {
    await dispatch(deleteEventeatingMeal({mealId, eventeatingId: eventeatings.id}))
  }


  return (

    <React.Fragment>

    <Typography variant="h5" style={{fontSize: 14}}>{name}</Typography>
      <List dense={true} style={{width:'40%'}}>
          <ListItem>
          <div style={{width: '300px'}}>
          <Select
        value={selectedValue}
        onChange={handleSelectChange}
        options={options}
        styles={customSelectStyle}
      />

          </div>
              <IconButton edge="end" aria-label="add" disabled={options.length === 0 ? true : false} onClick={handleAdd}>
                <AddIcon  />
              </IconButton>
          </ListItem>

          {
            dishes &&
            dishes.map(d => (
              <ListItem key={d.id}>
                <ListItemText classes={{primary:classes.listItemText}}
                  primary={`${d.id}. ${d.name}`}
                />
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="delete" onClick={e => {
                          handleDelete(d.id);
                        }}>
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))
          }
      </List>



    </React.Fragment>


  );
};


export default withAlert(Eating);
